import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Form } from '../..'
import { SettingsSection } from '../../../../../components/settings-section'
import { KeyValueInput } from '../../../../../inputs/key-value-input'
import { Stack } from '@mui/material'
import { useQuery } from '@apollo/client'
import { GetConfigVarsDocument } from '../../../../../generated/graphql'

export const CustomMetrics = () => {
  const { t } = useTranslation(['pos_profiles'])
  const { control } = useFormContext<Form>()
  const { data } = useQuery(GetConfigVarsDocument)
  const { dashboardPro } = data?.configVars || {}

  if (!dashboardPro) {
    return
  }
  return (
    <SettingsSection
      title={t('pos_profiles:custom_metrics_section.title')}
      description={t('pos_profiles:custom_metrics_section.description')}
    >
      <Stack gap={2} sx={{ p: 2, pt: 1 }}>
        <KeyValueInput
          name="custom_metrics"
          control={control}
          sx={{ width: '100%' }}
          buttonText={t(
            'pos_profiles:custom_metrics_section.add_custom_metric',
          )}
          placeholder={{
            key: t('pos_profiles:custom_metrics_section.key_placeholder'),
            value: t('pos_profiles:custom_metrics_section.title_placeholder'),
          }}
        />
      </Stack>
    </SettingsSection>
  )
}
